import * as yup from "yup";

export default yup.object().shape({
  password: yup.string().required("common.forms.passwordRequiredError"),
  email: yup.string().email("common.forms.emailFormatError").required("common.forms.emailRequiredError"),
});
